// extracted by mini-css-extract-plugin
export default {"rules_container":"FileUploadRules_rules_container__kesvW","sample_data_container":"FileUploadRules_sample_data_container__77Sdg"};